export const NAV = [
  { to: "/unternehmen", label: "Für Unternehmen" },
  { to: "/bewerber", label: "Für Bewerber" },
  { to: "/branchen", label: "Branchen" },
  { to: "/ablauf", label: "Ablauf" },
  { to: "/ueber-uns", label: "Über PACTORA" },
  { to: "/kontakt", label: "Kontakt" },
];

export const COMPANY = {
  brand: "PACTORA Personalpartner",
  street: "Stiller Winkel 5",
  city: "23562 Lübeck",
  email: "info@pactora-personal.de",
  mapsUrl: "https://www.openstreetmap.org/search?query=Stiller%20Winkel%205%2C%2023562%20L%C3%BCbeck",
};

export const INDUSTRIES = [
  {
    slug: "logistik", title: "Transport und Logistik", img: "/img/logistics.webp",
    roles: ["Lkw-Fahrer", "Lager", "Versand"],
    text: "Berufskraftfahrer für Nah- und Fernverkehr sowie Fachkräfte und Helfer für Lager, Kommissionierung und Versand.",
    note: "Für Berufskraftfahrer sind die Umschreibung bzw. Anerkennung der Fahrerlaubnis und die erforderlichen Qualifikationsnachweise vor Arbeitsbeginn zu klären.",
  },
  {
    slug: "handwerk", title: "Handwerk und Gebäudetechnik", img: "/img/craft.webp",
    roles: ["Elektriker", "Anlagenmechaniker SHK", "Weitere Handwerksberufe"],
    text: "Elektriker, Anlagenmechaniker für Sanitär-, Heizungs- und Klimatechnik sowie weitere Handwerksberufe für Betriebe in ganz Deutschland.",
    note: "Ausländische Berufsabschlüsse werden je nach Beruf und Aufenthaltszweck auf Gleichwertigkeit geprüft.",
  },
  {
    slug: "industrie", title: "Industrie und Produktion", img: "/img/industry.webp",
    roles: ["Schweißer", "Maschinenbediener", "Produktionspersonal"],
    text: "Schweißer, Maschinen- und Anlagenbediener sowie Produktionspersonal für Fertigung, Montage und Qualitätssicherung.",
  },
  {
    slug: "gesundheit", title: "Gesundheit und Pflege", img: "/img/health.webp",
    roles: ["Ärzte", "Pflegekräfte", "Weitere Gesundheitsberufe"],
    text: "Ärztinnen und Ärzte, Pflegefachkräfte und weitere Gesundheitsberufe für Kliniken, Pflegeeinrichtungen und Praxen.",
    note: "Gesundheitsberufe sind reglementiert: Approbation, Berufserlaubnis bzw. Anerkennung und die erforderlichen Sprachnachweise müssen vor der eigenständigen Berufsausübung vorliegen.",
  },
  {
    slug: "gastronomie", title: "Gastronomie und Hotellerie", img: "/img/gastro.webp",
    roles: ["Küche", "Service", "Housekeeping"],
    text: "Köchinnen und Köche, Servicekräfte und Mitarbeitende für Hotellerie und Housekeeping.",
  },
  {
    slug: "reinigung", title: "Reinigung und Gebäudeservice", img: "/img/cleaning.webp",
    roles: ["Gebäudereinigung", "Unterhaltsreinigung", "Objektbetreuung"],
    text: "Fach- und Hilfskräfte für Gebäudereinigung, Unterhaltsreinigung und Objektbetreuung.",
  },
  {
    slug: "verwaltung", title: "Kaufmännische Berufe und Verwaltung", img: "/img/office.webp",
    roles: ["Büro", "Buchhaltung", "Sachbearbeitung"],
    text: "Kaufmännische Fachkräfte für Büroorganisation, Buchhaltung, Sachbearbeitung und Verwaltung.",
  },
  {
    slug: "weitere", title: "Weitere Berufsgruppen", img: "/img/warehouse2.webp",
    roles: ["Auf Anfrage"],
    text: "Sie suchen Personal für einen anderen Beruf? Sprechen Sie uns an – wir prüfen, ob wir geeignete Bewerberinnen und Bewerber vorstellen können.",
  },
];

export const STEPS_EMPLOYER = [
  { t: "Anfrage", d: "Sie schildern uns Ihren Personalbedarf über das Anfrageformular oder per E-Mail." },
  { t: "Bedarfsanalyse", d: "Gemeinsam klären wir Tätigkeit, Qualifikation, Erfahrung, Sprachniveau, Einsatzort, Arbeitszeit und Vergütung." },
  { t: "Konditionen vereinbaren", d: "Sie erhalten ein schriftliches Angebot mit Leistungen, Vermittlungsprovision und Zahlungsbedingungen." },
  { t: "Kandidaten vorstellen", d: "Wir wählen passende Personen aus unserem Bewerberpool aus, stellen Profile vor und koordinieren Gespräche." },
  { t: "Auswahl und Arbeitsvertrag", d: "Sie entscheiden über die Einstellung und schließen den Arbeitsvertrag direkt mit der Arbeitskraft." },
  { t: "Einreise- und Beschäftigungsschritte", d: "Wir begleiten die organisatorische Abstimmung zu Unterlagen, Visum, ggf. Anerkennung und Zustimmung der Behörden." },
  { t: "Arbeitsbeginn", d: "Wir stimmen den Starttermin mit Ihnen und der neuen Arbeitskraft ab." },
];

export const STEPS_CANDIDATE = [
  { t: "Registrieren", d: "Sie füllen das Bewerberformular aus und laden auf Wunsch Lebenslauf und Nachweise hoch." },
  { t: "Profil und Unterlagen prüfen", d: "Wir sehen uns Ihre Qualifikation, Erfahrung und Sprachkenntnisse an und melden uns bei offenen Fragen." },
  { t: "Passende Arbeitgeber suchen", d: "Unser Team in Deutschland sucht Unternehmen, deren Anforderungen zu Ihrem Profil passen." },
  { t: "Vorstellungsgespräch", d: "Wenn ein Arbeitgeber Interesse hat, organisieren wir ein Gespräch – meist zuerst per Video." },
  { t: "Arbeitsvertrag", d: "Entscheidet sich der Arbeitgeber für Sie, erhalten Sie einen Arbeitsvertrag direkt von diesem Unternehmen." },
  { t: "Visa- und Anerkennungsschritte", d: "Erforderliche Visa, Beschäftigungserlaubnisse und ggf. Berufsanerkennungen werden bei den zuständigen Stellen beantragt." },
  { t: "Arbeitsbeginn", d: "Nach Erteilung der erforderlichen Erlaubnisse reisen Sie ein und beginnen Ihre Tätigkeit." },
];

export const FAQ_HOME = [
  {
    q: "Was bedeutet Direktvermittlung?",
    a: "Bei der Direktvermittlung wird die Arbeitskraft direkt bei Ihrem Unternehmen angestellt. Sie schließen den Arbeitsvertrag selbst und zahlen das Gehalt. PACTORA erhält für die erfolgreiche Vermittlung eine vorab vereinbarte Provision. Eine Arbeitnehmerüberlassung oder Zeitarbeit bieten wir nicht an.",
  },
  {
    q: "Was kostet die Vermittlung für Unternehmen?",
    a: "Die Vermittlungsprovision wird vor Beginn der Zusammenarbeit individuell vereinbart. Sie erhalten ein transparentes Angebot mit klar beschriebenen Leistungen und Zahlungsbedingungen.",
  },
  {
    q: "Müssen Bewerber etwas bezahlen?",
    a: "Die Vermittlungsprovision wird mit dem Arbeitgeber vereinbart. Für die Registrierung in unserem Bewerberpool zahlen Bewerberinnen und Bewerber nichts.",
  },
  {
    q: "Wie lange dauert eine internationale Vermittlung?",
    a: "Das hängt vom Beruf, vom Herkunftsland, von den erforderlichen Anerkennungen und von der Bearbeitung durch Behörden und Auslandsvertretungen ab. Feste Bearbeitungszeiten können wir daher nicht zusagen. Wir informieren Sie aber laufend über den Stand.",
  },
  {
    q: "Garantiert PACTORA ein Visum oder eine Einstellung?",
    a: "Nein. Über Visa, Aufenthaltstitel und Anerkennungen entscheiden ausschließlich die zuständigen Behörden. Über die Einstellung entscheidet der jeweilige Arbeitgeber. Wir unterstützen bei der Vorbereitung und organisatorischen Abstimmung.",
  },
  {
    q: "Welche Deutschkenntnisse werden benötigt?",
    a: "Das hängt vom Beruf, vom Arbeitgeber und von den rechtlichen Voraussetzungen ab. In vielen Berufen – besonders in Gesundheit und Pflege – sind bestimmte Sprachnachweise verpflichtend. Wir klären die Anforderungen im Einzelfall.",
  },
];

export const FAQ_EMPLOYER = [
  {
    q: "Haben Sie sofort verfügbare Mitarbeiter?",
    a: "Wir arbeiten mit einem Bewerberpool und suchen gezielt nach Ihrem Bedarf. Ob und wann passende Personen verfügbar sind, hängt vom Beruf, den Anforderungen und den rechtlichen Schritten ab. Das besprechen wir offen in der Bedarfsanalyse.",
  },
  {
    q: "Wer ist Arbeitgeber der vermittelten Person?",
    a: "Ihr Unternehmen. Der Arbeitsvertrag wird direkt zwischen Ihnen und der Arbeitskraft geschlossen, Sie zahlen das Gehalt. PACTORA ist Vermittler, nicht Arbeitgeber.",
  },
  {
    q: "Welche Aufgaben übernimmt mein Unternehmen?",
    a: "Sie definieren die Anforderungen, führen Vorstellungsgespräche, entscheiden über die Einstellung und stellen die für behördliche Verfahren erforderlichen Arbeitgeberangaben bereit – etwa die Erklärung zum Beschäftigungsverhältnis.",
  },
  ...FAQ_HOME.slice(1, 2),
  ...FAQ_HOME.slice(3, 5),
];

export const FAQ_CANDIDATE = [
  {
    q: "Welche Unterlagen brauche ich für die Registrierung?",
    a: "Für die erste Registrierung reichen Ihre Angaben im Formular. Wenn vorhanden, können Sie einen Lebenslauf und berufliche Nachweise (z. B. Abschlusszeugnisse, Arbeitszeugnisse, Sprachzertifikate) hochladen. Eine Passkopie oder Gesundheitsdaten benötigen wir dafür nicht.",
  },
  {
    q: "Kostet die Registrierung etwas?",
    a: "Nein. Die Registrierung in unserem Bewerberpool ist kostenlos.",
  },
  {
    q: "In welcher Sprache kann ich das Formular ausfüllen?",
    a: "Das Formular ist auf Deutsch. Ihre Antworten können Sie auch auf Englisch schreiben.",
  },
  ...FAQ_HOME.slice(3, 6),
];
